/*
export function someGetter (state) {
}
*/

import _ from 'lodash'

export function selectedFeApp (state) {
  if (!state.selectedFeAppId) {
    return null
  }
  return _.find(state.feApps, (feApp) => feApp.app.id === state.selectedFeAppId)
}

/**
 * feEntities indexed by entity ID
 * @param {*} state
 * @returns
 */
export function entById (state) {
  return _.keyBy(state.entities.list, (e) => e.entity.id)
}

/**
 * feDevices indexed by entity ID
 * @param {*} state
 * @returns
 */
export function devById (state) {
  return _.keyBy(state.devices.list, (e) => e.device.id)
}

/**
 * links indexed by id
 * @param {*} state
 * @returns
 */
export function lnkById (state) {
  return _.keyBy(state.links, (l) => l.id)
}

/**
 * links indexed by device ID
 * @param {*} state
 * @returns
 */
export function lnkByDev (state) {
  return _.groupBy(state.links, (l) => l.deviceId)
}

/**
 * links indexed by device ID
 * @param {*} state
 * @returns
 */
export function lnkByEnt (state) {
  return _.groupBy(state.links, (l) => l.entityId)
}

/**
 * return links indexed by compoundKey device ID then channel key
 *
 * returns
 *
 * {  "deviceID": {
        channels: {
          "<channelKey>": {
            linkId: "<linkid>",
            entityId: "<entityId>",
            streamKey: "<streamKey>"
            deviceId: "<deviceId>",
            channelKey: "<channelKey>"
          }
        },
        linkId: "<linkid>",
        deviceId: "<deviceId>"
      }
 * }
 *
 * logs error on duplicate device/channel combo
 */

export function lnkByDevChan (state, getters) {
  return _.keyBy(_.map(state.devices.list, (d) => {
    var obj = {
      id: d.device.id,
      channels: {
        // map to channel key
      }
    }

    var channelKeys = _.keys(d.device.channels)
    var links = getters.lnkByDev[d.device.id]
    _.each(links, (link) => {
      if (link.mappings) {
        _.each(link.mappings, (m) => { // for each mapping in the link
          if (_.includes(channelKeys, m.channel)) { // is the channel key def from this device
            if (obj.channels[m.channel]) {
              console.error('Channel key mapping link already define for device ' + d.device.id + ':' + m.channel)
            } else {
              obj.channels[m.channel] = { // for this channel, create a single lookup for link, device, entity and stream
                id: link.id,
                deviceId: d.device.id,
                entityId: link.entityId,
                streamKey: m.stream,
                channelKey: m.channel
              }
            }
          } else {
            console.warn('Linked channel key not found on device ' + d.device.id + ':' + m.channel)
          }
        })
      }
    })

    return obj
  }), 'id')
}

/**
 * return links indexed by compoundKey device ID then channel key
 *
 * returns
 *
 * {  "deviceID": {
        channels: {
          "<channelKey>": {
            linkId: "<linkid>",
            entityId: "<entityId>",
            streamKey: "<streamKey>"
            deviceId: "<deviceId>",
            channelKey: "<channelKey>"
          }
        },
        linkId: "<linkid>",
        deviceId: "<deviceId>"
      }
 * }
 *
 * logs error on duplicate device/channel combo
 */
export function lnkByEntStrm (state, getters) {
  return _.keyBy(_.map(state.entities.list, (e) => {
    var obj = {
      id: e.entity.id,
      streams: {
        // map to channel key
      }
    }

    var streamKeys = _.keys(e.entity.streams)
    var links = getters.lnkByEnt[obj.id]
    _.each(links, (link) => {
      if (link.mappings) {
        _.each(link.mappings, (m) => { // for each mapping in the link
          if (_.includes(streamKeys, m.stream)) { // is the channel key def from this device
            if (obj.streams[m.stream]) {
              console.error('Stream key mapping link already define for entity ' + obj.id + ':' + m.stream)
            } else {
              obj.streams[m.stream] = { // for this channel, create a single lookup for link, device, entity and stream
                id: link.id,
                deviceId: link.deviceId,
                entityId: link.entityId,
                streamKey: m.stream,
                channelKey: m.channel
              }
            }
          } else {
            console.warn('Linked stream key not found on entity ' + obj.id + ':' + m.stream)
          }
        })
      }
    })

    return obj
  }), 'id')
}
